module.exports = __webpack_public_path__ + "img/bz2.dc0adaaf.jpg";